import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const GoBackLink = styled(Link)`
  color: ${({ theme }) => theme.palette.grey['500']};
  text-decoration: none;
`;
